module.exports = __webpack_public_path__ + "img/play-button-blue.2a0aece4.svg";